import React, { useState, useEffect, useReducer, useCallback, useContext } from "react";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Collapse from "@material-ui/core/Collapse";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
// import MessageModal from "../../components/MessageModal"
import ScheduleModal from "../../components/ScheduleModal";
import ConfirmationModal from "../../components/ConfirmationModal";
import toastError from "../../errors/toastError";
import moment from "moment";
// import { SocketContext } from "../../context/Socket/SocketContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import usePlans from "../../hooks/usePlans";
import "moment/locale/pt-br";
import SearchIcon from "@material-ui/icons/Search";
import FilterListIcon from "@material-ui/icons/FilterList";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Tooltip,
  Chip,
} from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import FormGroup from "@material-ui/core/FormGroup";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import AllInclusiveIcon from "@material-ui/icons/AllInclusive";

import "./Schedules.css"; // Importe o arquivo CSS

// Defina a função getUrlParam antes de usá-la
function getUrlParam(paramName) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(paramName);
}

const eventTitleStyle = {
  fontSize: "14px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
};

const reducer = (state, action) => {
  if (action.type === "LOAD_SCHEDULES") {
    const schedules = action.payload;
    const newSchedules = [];

    schedules.forEach((schedule) => {
      const scheduleIndex = state.findIndex((s) => s.id === schedule.id);
      if (scheduleIndex !== -1) {
        state[scheduleIndex] = schedule;
      } else {
        newSchedules.push(schedule);
      }
    });

    return [...state, ...newSchedules];
  }

  if (action.type === "UPDATE_SCHEDULES") {
    const schedule = action.payload;
    const scheduleIndex = state.findIndex((s) => s.id === schedule.id);

    if (scheduleIndex !== -1) {
      state[scheduleIndex] = schedule;
      return [...state];
    } else {
      return [schedule, ...state];
    }
  }

  if (action.type === "DELETE_SCHEDULE") {
    const scheduleId = action.payload;

    const scheduleIndex = state.findIndex((s) => s.id === scheduleId);
    if (scheduleIndex !== -1) {
      state.splice(scheduleIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    overflowX: "hidden",
    ...theme.scrollbarStyles,
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1, 0),
  },
  groupHeader: {
  position: "sticky",
  top: 0,
  zIndex: 3,
  background: theme.palette.primary.main,
  color: theme.palette.getContrastText(theme.palette.primary.main),
  padding: theme.spacing(1.25),
  margin: theme.spacing(1, 2, 0.5),
  borderRadius: 8,
  boxShadow: theme.palette.type === 'dark' ? '0 2px 8px rgba(0,0,0,0.35)' : theme.shadows[1],
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  },
  tableRow: {
    '&:hover': {
      background: theme.palette.action.hover,
    }
  },
  resumeCell: {
    maxWidth: 420,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  resumeCellMobile: {
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    alignItems: "flex-start",
    gap: 6,
  },
  filtersBar: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    justifyContent: 'flex-start',
    flexWrap: "wrap",
  },
  filtersBarMobile: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    alignItems: "stretch",
    justifyContent: 'flex-start',
  },
  filtersContainer: {
    // Ajuste dinâmico para claro/escuro
    background: theme.palette.type === 'dark'
      ? 'linear-gradient(135deg, #1f2937 0%, #0b1220 100%)'
      : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    borderRadius: 12,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    boxShadow: theme.palette.type === 'dark'
      ? '0 2px 10px rgba(0,0,0,0.35)'
      : '0 2px 8px rgba(0,0,0,0.1)',
    border: `1px solid ${theme.palette.divider}`,
  },
  searchField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      background: theme.palette.background.paper,
    },
  },
  selectField: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      background: theme.palette.background.paper,
    },
  },
  actionButton: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 600,
    margin: theme.spacing(0, 0.5),
  },
  searchIcon: {
    color: theme.palette.text.disabled,
  },
  mobileHeaderTitle: {
    paddingLeft: 16,
    paddingRight: 16,
    width: '100%',
    boxSizing: 'border-box'
  },
  mobileHeaderButtonBar: {
    paddingLeft: 16,
    paddingRight: 16,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  mobileFiltersToggleBar: {
    paddingLeft: 16,
    paddingRight: 16,
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(1)
  }
}));

const Schedules = () => {
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  //   const socketManager = useContext(SocketContext);
  const { user, socket } = useContext(AuthContext);


  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [deletingSchedule, setDeletingSchedule] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [deleteModeDialogOpen, setDeleteModeDialogOpen] = useState(false);
  const [deleteMode, setDeleteMode] = useState("one");
  const [searchParam, setSearchParam] = useState("");
  const [schedules, dispatch] = useReducer(reducer, []);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [contactId, setContactId] = useState(+getUrlParam("contactId"));
  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);
  const [duplicateSource, setDuplicateSource] = useState(null);
  const [dupInitialSchedule, setDupInitialSchedule] = useState(null);
  const [filtersOpen, setFiltersOpen] = useState(false);

  useEffect(() => {
    // No desktop, filtros sempre abertos; no mobile, fechados por padrão
    if (!isMobile) setFiltersOpen(true);
    else setFiltersOpen(false);
  }, [isMobile]);
  // Filtros
  const [startDate, setStartDate] = useState(""); // YYYY-MM-DD
  const [endDate, setEndDate] = useState(""); // YYYY-MM-DD
  const [statusFilter, setStatusFilter] = useState([]); // ["PENDENTE","AGENDADA","ENVIADA","ERRO"]
  const [hasMediaOnly, setHasMediaOnly] = useState(false);
  const [seriesMode, setSeriesMode] = useState("all"); // all | series | single

  const { getPlanCompany } = usePlans();

  useEffect(() => {
    async function fetchData() {
      const companyId = user.companyId;
      const planConfigs = await getPlanCompany(undefined, companyId);
      if (!planConfigs.plan.useSchedules) {
        toast.error("Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.");
        setTimeout(() => {
          history.push(`/`)
        }, 1000);
      }
    }
    fetchData();
  }, [user, history, getPlanCompany]);

  const fetchSchedules = useCallback(async () => {
    try {
      const { data } = await api.get("/schedules", {
        params: { searchParam, pageNumber },
      });

      dispatch({ type: "LOAD_SCHEDULES", payload: data.schedules });
      setHasMore(data.hasMore);
      setLoading(false);
    } catch (err) {
      toastError(err);
    }
  }, [searchParam, pageNumber]);

  const handleOpenScheduleModalFromContactId = useCallback(() => {
    if (contactId) {
      handleOpenScheduleModal();
    }
  }, [contactId]);

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      fetchSchedules();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [
    searchParam,
    pageNumber,
    contactId,
    fetchSchedules,
    handleOpenScheduleModalFromContactId,
  ]);

  useEffect(() => {
    // handleOpenScheduleModalFromContactId();
    // const socket = socketManager.GetSocket(user.companyId, user.id);


    const onCompanySchedule = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_SCHEDULES", payload: data.schedule });
      }

      if (data.action === "delete") {
        // Quando deleção em série ocorrer, faça um refresh geral
        if (data.deleted && data.deleted > 1) {
          dispatch({ type: "RESET" });
          setPageNumber(1);
          fetchSchedules();
        } else {
          dispatch({ type: "DELETE_SCHEDULE", payload: +data.scheduleId });
        }
      }
    }

    socket.on(`company${user.companyId}-schedule`, onCompanySchedule)

    return () => {
      socket.off(`company${user.companyId}-schedule`, onCompanySchedule)
    };
  }, [socket]);

  const cleanContact = () => {
    setContactId("");
  };

  const handleOpenScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(true);
  };

  const handleCloseScheduleModal = () => {
    setSelectedSchedule(null);
    setScheduleModalOpen(false);
  // Evitar reaproveitar um initialSchedule antigo
  setDupInitialSchedule(null);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleEditSchedule = (schedule) => {
    setSelectedSchedule(schedule);
    setScheduleModalOpen(true);
  };

  const handleOpenDuplicateDialog = (schedule) => {
    setDuplicateSource(schedule);
    setDuplicateDialogOpen(true);
  };

  const closeDuplicateDialog = () => {
    setDuplicateDialogOpen(false);
    setDuplicateSource(null);
  };

  const openDuplicateModal = (mode) => {
    if (!duplicateSource) return;
    // Monta objeto para pré-preencher o ScheduleModal (sem mídia)
    const base = duplicateSource;
    let contactIdToUse = null;

    // Aceita tanto 'same' (botão do diálogo) quanto 'same-contact'
    if (mode === 'same' || mode === 'same-contact') {
      contactIdToUse = base.contactId || (base.contact && base.contact.id);
    }

    // Garantir sendAt mínimo de 15 minutos à frente
    const minSendAt = moment().add(15, 'minutes');
    const baseSend = base.sendAt ? moment(base.sendAt) : null;
    const computedSendAt = baseSend && baseSend.isValid() && baseSend.isAfter(minSendAt)
      ? baseSend
      : minSendAt;

    const initialSchedule = {
      body: base.body || '',
      contactId: contactIdToUse || '',
      whatsappId: base.whatsappId || '',
      openTicket: base.openTicket || 'enabled',
      statusTicket: base.statusTicket || 'closed',
      intervalo: base.intervalo || 1,
      valorIntervalo: base.valorIntervalo || 0,
      enviarQuantasVezes: base.enviarQuantasVezes || 1,
      tipoDias: base.tipoDias || 4,
      assinar: !!base.assinar,
      sendAt: computedSendAt.format('YYYY-MM-DDTHH:mm'),
      mediaPath: null,
      mediaName: null
    };

    setDupInitialSchedule(initialSchedule);
    setDuplicateDialogOpen(false);
    setScheduleModalOpen(true);
  };

  const handleDeleteSchedule = async (scheduleId) => {
    try {
      await api.delete(`/schedules/${scheduleId}`, { params: { mode: deleteMode } });
      toast.success(i18n.t("schedules.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingSchedule(null);
    setDeleteMode("one");
    setSearchParam("");
    setPageNumber(1);

    dispatch({ type: "RESET" });
    setPageNumber(1);
    await fetchSchedules();
  };

  const loadMore = () => {
    setPageNumber((prevState) => prevState + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading) return;
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const truncate = (str, len) => {
    if (str.length > len) {
      return str.substring(0, len) + "...";
    }
    return str;
  };

  const filteredAndSorted = React.useMemo(() => {
    let arr = [...schedules];
    // busca textual (contato/body)
    if (searchParam) {
      arr = arr.filter(s =>
        (s?.contact?.name || "").toLowerCase().includes(searchParam) ||
        (s?.body || "").toLowerCase().includes(searchParam)
      );
    }
    // período (por dia)
    if (startDate) {
      const start = moment(startDate, 'YYYY-MM-DD').startOf('day');
      arr = arr.filter(s => moment(s.sendAt).isSameOrAfter(start));
    }
    if (endDate) {
      const end = moment(endDate, 'YYYY-MM-DD').endOf('day');
      arr = arr.filter(s => moment(s.sendAt).isSameOrBefore(end));
    }
    // status
    if (Array.isArray(statusFilter) && statusFilter.length > 0) {
      arr = arr.filter(s => statusFilter.includes(s.status));
    }
    // has media
    if (hasMediaOnly) {
      arr = arr.filter(s => !!s.mediaPath);
    }
    // series mode
    if (seriesMode === 'series') {
      arr = arr.filter(s => !!s.seriesId);
    } else if (seriesMode === 'single') {
      arr = arr.filter(s => !s.seriesId);
    }
    // ordenar por sendAt asc
    arr.sort((a, b) => new Date(a.sendAt) - new Date(b.sendAt));
    return arr;
  }, [schedules, searchParam, startDate, endDate, statusFilter, hasMediaOnly, seriesMode]);

  const groupedByDate = React.useMemo(() => {
    const groups = {};
    filteredAndSorted.forEach(s => {
      const key = moment(s.sendAt).format('YYYY-MM-DD');
      if (!groups[key]) groups[key] = [];
      groups[key].push(s);
    });
    // retornar como array ordenado por data
    return Object.keys(groups)
      .sort()
      .map(key => ({
        key,
        title: moment(key, 'YYYY-MM-DD').format('ddd, DD/MM/YYYY'),
        items: groups[key]
      }));
  }, [filteredAndSorted]);

  return (
    <>
    <MainContainer>
      <ConfirmationModal
        title={
          deletingSchedule &&
          `${i18n.t("schedules.confirmationModal.deleteTitle")}`
        }
        open={confirmModalOpen}
        onClose={() => setConfirmModalOpen(false)}
        onConfirm={() => handleDeleteSchedule(deletingSchedule.id)}
      >
        {i18n.t("schedules.confirmationModal.deleteMessage")}
      </ConfirmationModal>
      {/* Diálogo para escolher modo de exclusão quando for uma série */}
      <Dialog open={deleteModeDialogOpen} onClose={() => setDeleteModeDialogOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>Excluir agendamento</DialogTitle>
        <DialogContent>
          Este agendamento faz parte de uma série. O que deseja excluir?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setDeleteMode("one"); setDeleteModeDialogOpen(false); setConfirmModalOpen(true); }} color="primary" variant="outlined">
            Apenas este
          </Button>
          <Button onClick={() => { setDeleteMode("seriesPending"); setDeleteModeDialogOpen(false); setConfirmModalOpen(true); }} color="primary" variant="outlined">
            Somente pendentes
          </Button>
          <Button onClick={() => { setDeleteMode("seriesAll"); setDeleteModeDialogOpen(false); setConfirmModalOpen(true); }} color="secondary" variant="contained">
            Toda a série
          </Button>
        </DialogActions>
      </Dialog>
      {scheduleModalOpen && (
        <ScheduleModal
          open={scheduleModalOpen}
          onClose={handleCloseScheduleModal}
          reload={fetchSchedules}
          // aria-labelledby="form-dialog-title"
          scheduleId={
            selectedSchedule ? selectedSchedule.id : null
          }
          contactId={contactId}
          cleanContact={cleanContact}
          initialSchedule={dupInitialSchedule}
        />
      )}
      <MainHeader>
        <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
          {isMobile ? (
            <>
              <Box className={classes.mobileHeaderTitle}>
                <Title>({filteredAndSorted.length}) {i18n.t("schedules.title")}</Title>
              </Box>
              <Box className={classes.mobileHeaderButtonBar}>
                <Button
                  className={classes.actionButton}
                  variant="contained"
                  color="primary"
                  onClick={handleOpenScheduleModal}
                >
                  {i18n.t("schedules.buttons.add")}
                </Button>
              </Box>
              <Box className={classes.mobileFiltersToggleBar}>
                <Button
                  startIcon={<FilterListIcon />}
                  className={classes.actionButton}
                  variant="outlined"
                  onClick={() => setFiltersOpen(prev => !prev)}
                >
                  Filtros
                </Button>
              </Box>
              <Collapse in={filtersOpen} timeout="auto" unmountOnExit>
                <Card className={classes.filtersContainer} elevation={3} style={{ marginLeft: 16, marginRight: 16 }}>
                  <CardContent>
                    <div className={classes.filtersBarMobile}>
                      <TextField
                        className={classes.searchField}
                        placeholder={i18n.t("contacts.searchPlaceholder")}
                        type="search"
                        value={searchParam}
                        onChange={handleSearch}
                        size="small"
                        variant="outlined"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon className={classes.searchIcon} />
                            </InputAdornment>
                          ),
                        }}
                        style={{ width: '100%' }}
                      />
                      <TextField
                        className={classes.selectField}
                        label="Início"
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        size="small"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        style={{ width: '100%' }}
                      />
                      <TextField
                        className={classes.selectField}
                        label="Fim"
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        size="small"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        style={{ width: '100%' }}
                      />
                      <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                        <Typography variant="body2" color="textSecondary" style={{ marginRight: 8 }}>Recorrente:</Typography>
                        <RadioGroup
                          row
                          aria-label="recorrente"
                          name="recorrente"
                          value={seriesMode}
                          onChange={(e) => setSeriesMode(e.target.value)}
                        >
                          <FormControlLabel value="all" control={<Radio color="primary" />} label="Todos" />
                          <FormControlLabel value="series" control={<Radio color="primary" />} label="Recorrentes" />
                          <FormControlLabel value="single" control={<Radio color="primary" />} label="Avulsos" />
                        </RadioGroup>
                      </Box>
                      <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                        <Typography variant="body2" color="textSecondary" style={{ marginRight: 4 }}>Status:</Typography>
                        <FormGroup row>
                          {['PENDENTE','AGENDADA','ENVIADA','ERRO'].map(s => (
                            <FormControlLabel
                              key={s}
                              control={
                                <Checkbox
                                  color="primary"
                                  checked={statusFilter.includes(s)}
                                  onChange={(e) => setStatusFilter(prev => e.target.checked ? [...prev, s] : prev.filter(x => x !== s))}
                                />
                              }
                              label={s}
                            />
                          ))}
                        </FormGroup>
                      </Box>
                      <FormControlLabel
                        control={<Checkbox color="primary" checked={hasMediaOnly} onChange={(e) => setHasMediaOnly(e.target.checked)} />}
                        label="Com anexo"
                      />
                      <Button
                        className={classes.actionButton}
                        variant="outlined"
                        onClick={() => { setSearchParam(""); setStartDate(""); setEndDate(""); setStatusFilter([]); setHasMediaOnly(false); setSeriesMode("all"); }}
                      >
                        Limpar filtros
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Collapse>
            </>
          ) : (
            <>
              <Box className={classes.headerContainer} style={{ paddingLeft: 16, paddingRight: 16, width: '100%', boxSizing: 'border-box' }}>
                <Title>{i18n.t("schedules.title")} ({filteredAndSorted.length})</Title>
                <div>
                  <Button
                    className={classes.actionButton}
                    variant="contained"
                    color="primary"
                    onClick={handleOpenScheduleModal}
                  >
                    {i18n.t("schedules.buttons.add")}
                  </Button>
                </div>
              </Box>
              <Card className={classes.filtersContainer} elevation={3} style={{ marginLeft: 16, marginRight: 16 }}>
                <CardContent>
                  <div className={classes.filtersBar}>
                    <TextField
                      className={classes.searchField}
                      placeholder={i18n.t("contacts.searchPlaceholder")}
                      type="search"
                      value={searchParam}
                      onChange={handleSearch}
                      size="small"
                      variant="outlined"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon className={classes.searchIcon} />
                          </InputAdornment>
                        ),
                      }}
                      style={{ minWidth: 240 }}
                    />
                    <TextField
                      className={classes.selectField}
                      label="Início"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                      size="small"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      style={{ minWidth: 160 }}
                    />
                    <TextField
                      className={classes.selectField}
                      label="Fim"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      size="small"
                      variant="outlined"
                      InputLabelProps={{ shrink: true }}
                      style={{ minWidth: 160 }}
                    />
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                      <Typography variant="body2" color="textSecondary" style={{ marginRight: 8 }}>Recorrente:</Typography>
                      <RadioGroup
                        row
                        aria-label="recorrente"
                        name="recorrente"
                        value={seriesMode}
                        onChange={(e) => setSeriesMode(e.target.value)}
                      >
                        <FormControlLabel value="all" control={<Radio color="primary" />} label="Todos" />
                        <FormControlLabel value="series" control={<Radio color="primary" />} label="Recorrentes" />
                        <FormControlLabel value="single" control={<Radio color="primary" />} label="Avulsos" />
                      </RadioGroup>
                    </Box>
                    <Box display="flex" alignItems="center" style={{ gap: 8 }}>
                      <Typography variant="body2" color="textSecondary" style={{ marginRight: 4 }}>Status:</Typography>
                      <FormGroup row>
                        {['PENDENTE','AGENDADA','ENVIADA','ERRO'].map(s => (
                          <FormControlLabel
                            key={s}
                            control={
                              <Checkbox
                                color="primary"
                                checked={statusFilter.includes(s)}
                                onChange={(e) => setStatusFilter(prev => e.target.checked ? [...prev, s] : prev.filter(x => x !== s))}
                              />
                            }
                            label={s}
                          />
                        ))}
                      </FormGroup>
                    </Box>
                    <FormControlLabel
                      control={<Checkbox color="primary" checked={hasMediaOnly} onChange={(e) => setHasMediaOnly(e.target.checked)} />}
                      label="Com anexo"
                    />
                    <Button
                      className={classes.actionButton}
                      variant="outlined"
                      onClick={() => { setSearchParam(""); setStartDate(""); setEndDate(""); setStatusFilter([]); setHasMediaOnly(false); setSeriesMode("all"); }}
                    >
                      Limpar filtros
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </>
          )}
        </Box>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined" onScroll={handleScroll}>
        {groupedByDate.map(group => (
          <div key={group.key}>
            <div className={classes.groupHeader}>
              <div style={{ fontWeight: 600 }}>{group.title}</div>
              <div style={{ opacity: 0.7 }}>{group.items.length}</div>
            </div>

            {!isMobile ? (
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Contato</TableCell>
                    <TableCell>Resumo</TableCell>
                    <TableCell>Data de envio</TableCell>
                    <TableCell>Anexo</TableCell>
                    <TableCell>Usuário</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {group.items.map((schedule) => (
                    <TableRow key={schedule.id} hover className={classes.tableRow}>
                      <TableCell>
                        {schedule?.contact?.name || '—'}
                      </TableCell>
                      <TableCell>
                        <div className={classes.resumeCell}>
                          {schedule.mediaPath && (
                            <Tooltip title={schedule.mediaName || 'Anexo'}>
                              <AttachFileIcon fontSize="small" style={{ opacity: 0.7 }} />
                            </Tooltip>
                          )}
                          {schedule.seriesId && (
                            <Tooltip title={`Série${schedule.totalOccurrences ? ` (${schedule.occurrenceIndex + 1}/${schedule.totalOccurrences})` : ''}`}>
                              <AllInclusiveIcon fontSize="small" style={{ opacity: 0.7 }} />
                            </Tooltip>
                          )}
                          <span title={schedule.body || ''}>
                            {truncate((schedule.body || '').split('\n')[0], 80)}
                          </span>
                        </div>
                      </TableCell>
                      <TableCell>{moment(schedule.sendAt).format('DD/MM/YYYY HH:mm')}</TableCell>
                      <TableCell>
                        {schedule.mediaPath ? (
                          <Chip label="Sim" color="primary" size="small" />
                        ) : (
                          <Chip label="Não" variant="outlined" size="small" />
                        )}
                      </TableCell>
                      <TableCell>{schedule?.user?.name || '—'}</TableCell>
                      <TableCell align="right">
                        <Tooltip title="Excluir">
                          <DeleteOutlineIcon
                            onClick={() => {
                              setDeletingSchedule(schedule);
                              if (schedule.seriesId) {
                                setDeleteModeDialogOpen(true);
                              } else {
                                setDeleteMode("one");
                                setConfirmModalOpen(true);
                              }
                            }}
                            style={{ cursor: 'pointer', marginRight: 8 }}
                          />
                        </Tooltip>
                        <Tooltip title="Editar">
                          <EditIcon
                            onClick={() => {
                              handleEditSchedule(schedule);
                              setScheduleModalOpen(true);
                            }}
                            style={{ cursor: 'pointer', marginRight: 8 }}
                          />
                        </Tooltip>
                        <Tooltip title="Duplicar">
                          <FileCopyIcon
                            onClick={() => handleOpenDuplicateDialog(schedule)}
                            style={{ cursor: 'pointer' }}
                          />
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
              <div>
                {group.items.map((schedule) => (
                  <div key={schedule.id} style={{ padding: '12px 16px', borderBottom: `1px solid ${theme.palette.divider}` }}>
                    {/* Linha 1: Contato + Ações */}
                    <Box display="flex" alignItems="center" justifyContent="space-between" style={{ gap: 12 }}>
                      <Typography variant="subtitle2" style={{ fontWeight: 600, maxWidth: '70%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {schedule?.contact?.name || '—'}
                      </Typography>
                      <Box display="flex" alignItems="center">
                        <Tooltip title="Excluir">
                          <DeleteOutlineIcon
                            onClick={() => {
                              setDeletingSchedule(schedule);
                              if (schedule.seriesId) {
                                setDeleteModeDialogOpen(true);
                              } else {
                                setDeleteMode("one");
                                setConfirmModalOpen(true);
                              }
                            }}
                            style={{ cursor: 'pointer', marginRight: 12 }}
                          />
                        </Tooltip>
                        <Tooltip title="Editar">
                          <EditIcon
                            onClick={() => {
                              handleEditSchedule(schedule);
                              setScheduleModalOpen(true);
                            }}
                            style={{ cursor: 'pointer', marginRight: 12 }}
                          />
                        </Tooltip>
                        <Tooltip title="Duplicar">
                          <FileCopyIcon
                            onClick={() => handleOpenDuplicateDialog(schedule)}
                            style={{ cursor: 'pointer' }}
                          />
                        </Tooltip>
                      </Box>
                    </Box>

                    {/* Linha 2: Resumo + Data de envio */}
                    <Box display="flex" alignItems="flex-start" justifyContent="space-between" style={{ gap: 12, marginTop: 6 }}>
                      <Box display="flex" alignItems="flex-start" style={{ gap: 6, flex: 1, minWidth: 0 }}>
                        {schedule.mediaPath && (
                          <Tooltip title={schedule.mediaName || 'Anexo'}>
                            <AttachFileIcon fontSize="small" style={{ opacity: 0.7, marginTop: 2 }} />
                          </Tooltip>
                        )}
                        {schedule.seriesId && (
                          <Tooltip title={`Série${schedule.totalOccurrences ? ` (${schedule.occurrenceIndex + 1}/${schedule.totalOccurrences})` : ''}`}>
                            <AllInclusiveIcon fontSize="small" style={{ opacity: 0.7, marginTop: 2 }} />
                          </Tooltip>
                        )}
                        <Typography variant="body2" color="textSecondary" style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }} title={schedule.body || ''}>
                          {truncate((schedule.body || '').replace(/\n/g, ' '), 140)}
                        </Typography>
                      </Box>
                      <Typography variant="caption" color="textSecondary" style={{ whiteSpace: 'nowrap', marginLeft: 8 }}>
                        {moment(schedule.sendAt).format('DD/MM/YYYY HH:mm')}
                      </Typography>
                    </Box>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
        {groupedByDate.length === 0 && (
          <div style={{ padding: 16, opacity: 0.7 }}>Nenhum agendamento encontrado.</div>
        )}
      </Paper>
    </MainContainer>
    {/* Diálogo para escolher tipo de duplicação */}
    <Dialog open={duplicateDialogOpen} onClose={closeDuplicateDialog} maxWidth="xs" fullWidth>
      <DialogTitle>Duplicar agendamento</DialogTitle>
      <DialogContent>
        Selecione como deseja duplicar este agendamento:
      </DialogContent>
      <DialogActions>
        <Button onClick={() => openDuplicateModal("new")} color="primary" variant="outlined">
          Novo contato
        </Button>
        <Button onClick={() => openDuplicateModal("same")} color="primary" variant="contained">
          Mesmo contato
        </Button>
      </DialogActions>
    </Dialog>
    </>
  );
};

export default Schedules;